export const ORGANIZATION_PREMIUM_PLAN_REGISTRATION_URL =
  'https://forms.gle/NKPnZmRTctDBUFov7'
